/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrdersDashboardPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,
  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,
  sidebarOpen: PropTypes.bool,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
  width: PropTypes.string,
};

export default OrdersDashboardPropTypes;
